import React from "react";
import omit from "lodash/omit";
import random from "lodash/random";
import { graphql, useStaticQuery } from "gatsby";
import Img, { FluidObject, FixedObject, GatsbyImageProps } from "gatsby-image";

export const DefaultGatsbyImage = (
  props: Omit<
    Partial<GatsbyImageProps> & {
      seed: string;
      imgType: "fluid" | "fixed";
    },
    "fluid"
  >
) => {
  const defaultImage: {
    imageSharp: {
      fluid: FluidObject;
      fixed: FixedObject;
    };
  } = useStaticQuery(graphql`
    fragment DefaultHero on ImageSharp {
      fluid(maxWidth: 300, maxHeight: 300) {
        ...GatsbyImageSharpFluid
      }
      fixed(width: 300) {
        ...GatsbyImageSharpFixed
      }
    }

    query {
      imageSharp(original: { src: { regex: "/.*/default-hero/" } }) {
        ...DefaultHero
      }
    }
  `);

  let imgTypeProp =
    props.imgType === "fluid"
      ? { fluid: defaultImage.imageSharp.fluid }
      : { fixed: defaultImage.imageSharp.fixed };
  return (
    <Img
      {...omit(props, ["seed", "imgType"])}
      {...imgTypeProp}
      style={{
        ...props.style,
        filter: `hue-rotate(${(props.seed.length * 100) % 360}deg)`,
      }}
    />
  );
};
